import { Task } from 'taskarian';
import GroupStore from '.';
import { callApi } from '../Appy';
import { groupResourceDecoder } from '../GroupsStore/Decoders';
import { GroupResource } from '../GroupsStore/Types';
import { findLinkT } from '../LinkyLinky';
import { Link } from '../Resource/Types';
import { Creating, GroupError } from './Types';

const createNewUserGroup = (store: GroupStore, state: Creating) =>
  Task.succeed<GroupError, ReadonlyArray<Link>>(state.groupNewResource.links)
    .andThen(findLinkT('create'))
    .andThen(callApi(groupResourceDecoder, state.values));

const handleError = (store: GroupStore, state: Creating) => (error: GroupError) => {
  store.formSubmissionError(state.groupNewResource, error, state.template);
};

export const createUserGroup = (store: GroupStore, state: Creating) => {
  return createNewUserGroup(store, state).fork(handleError(store, state), (resource) =>
    groupUpdater(store, resource),
  );
};

export const groupUpdater = (store: GroupStore, resource: GroupResource) => {
  store.success(resource);
  store.groupsStore.addGroupToGroups(resource);
};
